import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Typography, Pill } from '@one-thd/sui-atomic-components';
import { emtContentDataModel } from '../dataModels';

export const BrandCategories = ({ contentId: propContentId, pageName }) => {
  const ctx = useContext(ExperienceContext);
  const nValue = propContentId || ctx?.customContext?.variables?.navParam;
  const contentId = nValue && nValue.indexOf('N-') < 0 ? `N-${nValue}` : nValue;
  const { loading, data, error } = useDataModel(
    'emtContent',
    {
      variables: {
        contentId,
        pageName
      },
      skip: !contentId
    }
  );

  const brandCategories = data?.emtContent?.content?.brandLinking;

  if (!data || loading || error || !brandCategories || brandCategories?.length === 0) {
    return null;
  }
  return (
    <div
      className="sui-flex sui-flex-col sui-w-full sui-gap-4"
      data-component="BrandCategories"
    >
      <Typography variant="h2" weight="display">{brandCategories?.title}</Typography>
      <div className="sui-flex sui-flex-row sui-flex-wrap sui-leading-tight sui-gap-4">
        {brandCategories?.links.map((links, index) => {
          const { anchortext, url } = links;

          return (
            <div
              className="sui-bg-primary sui-rounded-full"
              key={`brand-categories-${index}`}
            >
              <a className="hover:sui-no-underline" href={url}>
                <Pill
                  label={anchortext}
                  component="p"
                  clickable
                />
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};

BrandCategories.propTypes = {
  contentId: PropTypes.string,
  pageName: PropTypes.string.isRequired
};

BrandCategories.displayName = 'BrandCategories';

BrandCategories.dataModel = emtContentDataModel;